var shvenergy = shvenergy || {};

shvenergy.maps = (function ($) {
    "use strict";
    var mapsContainer = $("#map");
    var cdnvalue = $("#cdnInput").data("value");
    var initialLat = mapsContainer.data("lat"),
        initialLong = mapsContainer.data("long"),
        initialZoom = mapsContainer.data("zoom"),
        countryRestrictions = mapsContainer.data("country"),
        truncatelongdealernames = mapsContainer.data("truncatelongdealernames");

    var countryRestrictionsArray = countryRestrictions.split('|');

    var numberofsearchresultsbeforeserversideclustering =
        mapsContainer.data("numberofsearchresultsbeforeserversideclustering") || 1000;

    var getdirectionstext = mapsContainer.data("getdirectionstext") || "Get directions";

    var numberofsearchresultbeforeshowingsearchresults =
        mapsContainer.data("numberofsearchresultbeforeshowingsearchresults") || 50;

    var minimumnumbersofdealersshownonmapafterinitialsearch =
        mapsContainer.data("minimumnumbersofdealersshownonmapafterinitialsearch") || 50;

    var map;
    var mapservice;
    var defaultPosition = { lat: initialLat, lng: initialLong };
    var initialPosition = { lat: initialLat, lng: initialLong };
    var markers = [];
    var markerClusterer;
    var imagePath = document.documentElement.lang.toLowerCase() !== "pt" ? "" + cdnvalue + "/dist/images/maps/m" : "" + cdnvalue + "/dist/images/maps/supergasbras/m";

    var useClusterSizeAsText = document.documentElement.lang.toLowerCase() !== "pt" ? true : false;

    var intro = $(".map-sidebar__intro");
    var mapSidebar = $("#map-sidebar");
    var searchZoomLevel = 12;

    var errorMessage = $(".search__details--error__headline");

    var mcOptions = {
        gridSize: 100,
        maxZoom: 22,
        zoomOnClick: true,
        averageCenter: true,
        imagePath: imagePath,
        styles: {
            textColor: "#fff"
        }
    };

    var isZoomedAndCenteredOnMarker = false;
    var resultList = $(".search__list.search__pane");
    var resultListWarning = $(".search__list-warning");
    var dealerTarget = $("#dealerTarget");
    var dealerTemplate = $("#dealerTemplate");
    var distanceUnit = dealerTarget.data("distanceunit");

    var currentBounds = null;
    var currentZoom = null;

    var infoBox = null;
    var infoBoxDefaultOptions = {
        disableAutoPan: true,
        alignBottom: true,
        maxWidth: 0,
        zIndex: null,
        boxStyle: {
            width: "280px"
        },
        closeBoxMargin: "10px 2px 2px 2px",
        closeBoxURL: "",
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: false
    };

    var currentLocationMarker = '' + cdnvalue + '/dist/images/maps/my-location.svg';

    var mapStyles = shvenergy.maputils.mapStyles;

    var keepSearchingIfNoResults = false;

    // Keep track of the active marker for handling simulated click
    var activeMarker = null;

    //https://mapstyle.withgoogle.com/

    function usePreferredPartenerLabel() {
        return $('input[name=toggle]:checked').data("promotepreferredpartner").toUpperCase() === "TRUE" ? true : false;
    }

    var locationMarker;
    var geoCoder = new google.maps.Geocoder();

    function extractLabelFromFilter() {
        const type = shvenergy.search.dealer.getType();
        const name = `#${type}-dealerPromotedPreferredPartnerFilter`;
        const el = $(name);
        let legend = "";

        if (el.length > 0) {
            const label = el.next("label");
            legend = label.find(".filter__title").text();
        }

        return legend;
    }

    function extractIconAndLabelFromFilter() {
        const type = shvenergy.search.dealer.getType();
        const name = `#${type}-dealerPromotedPreferredPartnerFilter`;
        const el = $(name);
        let icon = "";
        let legend = "";

        if (el.length > 0) {
            const label = el.next("label");
            icon = label.find(".small-icon__wrapper").html();
            legend = label.find(".filter__title").text();
        }

        return `${icon}${legend}`;
    }

    function getMobileAddressSettings() {
        const toggles = $('[name=toggle]');
        const selector = toggles.length === 1
            ? '[name=toggle]'
            : '[name=toggle]:checked';

        const showAddressInDealerPreviewBox = Boolean($(selector).data('mobileshowaddressindealerpreviewbox')) || false;
        const showAddressInListView = Boolean($(selector).data('mobileshowaddressinlistview')) || false;

        return {
            showAddressInDealerPreviewBox,
            showAddressInListView
        };
    };

    $.addTemplateFormatter({
        UpperCaseFormatter: function (value, template) {
            return value.toUpperCase();
        },
        LowerCaseFormatter: function (value, template) {
            return value.toLowerCase();
        },
        SameCaseFormatter: function (value, template) {
            if (template == "upper") {
                return value.toUpperCase();
            } else {
                return value.toLowerCase();
            }
        },
        DealerFirstPhoneNumberFormatter: function (value, template) {
            if (value.length > 0)
                return value[0];
            else return "";
        },
        DealerAddressFormatter: function (value, template) {
            if (value) {
                return value + "<br>";
            }
            else return "";
        },
        DealerShortAddressFormatter: function (value) {
            const { showAddressInListView } = getMobileAddressSettings();

            if (showAddressInListView) {
                return value;
            }
            return '';
        },
        DealerDistanceFormatter: function (value, template) {
            if (value) {
                return value + " " + distanceUnit;
            }
            else return "";
        },
        DealerIdFormatter: function (value, template) {
            return "dealer" + value;
        },
        //DealerIconFormatter: function (value, template) {
        //    return "/dist/images/maps/" + iconResolver(value);
        //},
        DealerIconFormatter2: function (value, template) {
            return getDealerIcon(value);
        },
        DealerPromotedPreferredPartnerFormatter: function (value, template) {

            if (usePreferredPartenerLabel() && value) {
                return extractIconAndLabelFromFilter();
            }
            return "";
        }
    });

    var selectFirstOnEnter = function (input) {

        // store the original event binding function
        var eventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
        function addEventListenerWrapper(type, listener) {
            if (type == "keydown") {
                var origListener = listener;
                listener = function (event) {
                    var suggestionSelected = $(".pac-item-selected").length > 0;
                    if (event.which == 13 && !suggestionSelected) {
                        var simulatedDownarrow = $.Event("keydown", { keyCode: 40, which: 40 });
                        origListener.apply(input, [simulatedDownarrow]);
                    }
                    origListener.apply(input, [event]);
                };
            }
            // add the modified listener
            eventListener.apply(input, [type, listener]);
        }

        if (input.addEventListener) {
            input.addEventListener = addEventListenerWrapper;
        } else if (input.attachEvent) {
            input.attachEvent = addEventListenerWrapper;
        }
    };

    function setDefaultFilterFromUrlParam() {
        var dealerTypeParams = shvenergy.utils.getUrlParameter('dealerType'); // "edit"

        if (dealerTypeParams && dealerTypeParams.length) {
            switch (dealerTypeParams) {
                case "Cylinder":
                    shvenergy.search.dealer.setType("Cylinder");
                    $(".toggle[value='Cylinder']").prop("checked", true);
                    if ($(".toggle[value='Cylinder']").data('hideavailablefiltersbutton') == true) {
                        $('.search__back--filter').hide();
                    } else {
                        const checkboxes = $(`input[type="checkbox"][data-dealertypename="Cylinder"]`)
                        const disabled = checkboxes.length === 0;
                        $('.search__back--filter').attr('disabled', disabled);
                    }
                    break;
                case "Autogas":
                    shvenergy.search.dealer.setType("Autogas");
                    $(".toggle[value='Autogas']").prop("checked", true);
                    if ($(".toggle[value='Autogas']").data('hideavailablefiltersbutton') == true) {
                        $('.search__back--filter').hide();
                    } else {
                        const checkboxes = $(`input[type="checkbox"][data-dealertypename="Autogas"]`)
                        const disabled = checkboxes.length === 0;
                        $('.search__back--filter').attr('disabled', disabled);
                    }
                    break;
            }
        } else {
            if ($(".toggle").data('hideavailablefiltersbutton') == true) {
                $('.search__back--filter').hide();
            } else {
                const shouldDisable = $('input[type="checkbox"][data-dealertypename]').length === 0
                $('.search__back--filter').attr('disabled', disabled);
            }
        }
    }

    window.onpopstate = function (event) {
        //console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`);

        var searchParams = shvenergy.utils.getUrlParameter('search'); // "edit"
        var dealerId = shvenergy.utils.getUrlParameter('dealerId');
        var viewType = shvenergy.utils.getUrlParameter("view");

        if (dealerId) {
            goToDealerFromURLId(dealerId);
        } else {
            shvenergy.maps.getLocationFromAddress(searchParams);
            shvenergy.search.gui.setCurrentSearch(searchParams);
            setDefaultFilterFromUrlParam();

            // update checkbox values base on url
            let urlSearchParameters = new URLSearchParams(window.location.search).getAll("filter");
            if (urlSearchParameters) {
                var type = shvenergy.search.dealer.getType();
                let currentCheckedInputs = $("input[data-dealertypename='" + type + "']");
                currentCheckedInputs.prop("checked", false);
                urlSearchParameters.forEach(item => $("input[data-queryparametername='" + item + "'][data-dealertypename='" + type + "']").prop("checked", true))
                shvenergy.search.filters.updateFilterCount();
            }

            if (searchParams === "") {
                setTimeout(function () {
                    shvenergy.maps.intro.show();
                    $("#dealerTarget").empty();
                    $("#map-searchinput").val("");
                    shvenergy.search.gui.setBactoStartState(true);
                    shvenergy.maps.setZoom(shvenergy.maps.initialZoom);
                    shvenergy.maps.setCenter(shvenergy.maps.initialPosition);
                    // shvenergy.search.filters.resetFilters();
                    shvenergy.search.gui.mapClearSearchButtonStore.clearSearchButtonVisible = false;
                    shvenergy.maps.hideMarker();
                    $(".map-dealerdetails").removeClass("isActive");
                    removeMobileInfoBoxes()

                    if (shvenergy.cookies.getCookie("isTouch") === "true") {
                        shvenergy.search.gui.mapStateStore.mapVisible = true;
                    }
                }, 50);
            }

            switch (viewType) {
                case "map":
                    shvenergy.search.gui.mapStateStore.mapVisible = true;
                    break;

                case "list":
                    shvenergy.search.gui.mapStateStore.mapVisible = false;
                    break;

                default:
                    shvenergy.search.gui.mapStateStore.mapVisible = true;
                    break;
            }
        }

        if ($(".map-dealerdetails").hasClass("isActive")) {
            shvenergy.search.gui.hideDetails();
        }
    }

    function goToDealerFromURLId(dealerId, maxTries = 20) {
        if (map) {
            var coordinates = {
                lat: shvenergy.utils.getUrlParameter('lat'),
                lng: shvenergy.utils.getUrlParameter('lng')
            }

            if (dealerId) {
                var viewType = shvenergy.utils.getUrlParameter('view');

                var myLatlng = new google.maps.LatLng(coordinates.lat, coordinates.lng);
                setCenter(myLatlng);
                map.setZoom(15);
                // shvenergy.search.gui.mapStateStore.mapVisible = true;

                if (viewType === 'details') {
                    if (shvenergy.cookies.getCookie('isTouch') === 'true') {
                        // Open first details-popup on mobile
                        activeMarker = dealerId;
                    } else {
                        // Show details-view
                        loadDealer(dealerId);
                    }
                }

                // mapSidebar.addClass("is-invisible");
            }
        } else if (maxTries > 0) {
            setTimeout(function () {
                goToDealerFromURLId(dealerId, maxTries - 1);
            }, 50);
        }
    }

    function clickMarkerById(id) {
        setTimeout(() => {
            var marker = getMarkerById(id);
            google.maps.event.trigger(marker, 'click');
            activeMarker = null;
        }, 200);
    }

    function initializeAutocomplete(input = document.getElementById('map-searchinput')) {
        var countryRestrictionsOptions = {};
        if (countryRestrictionsArray.includes("gb") && countryRestrictionsArray.includes("ie")) {
            //NOTE! this is a special scenario for Ireland
            //Ireland only want search results from Ireland and Northern Ireland, NOT the rest of the UK
            var irelandBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(50.999929, -10.854492),
                new google.maps.LatLng(55.354135, -5.339355));


            countryRestrictionsOptions = {
                bounds: irelandBounds,
                strictBounds: true
            };
        }

        var autocomplete = new google.maps.places.Autocomplete(input, countryRestrictionsOptions);

        selectFirstOnEnter(input);

        autocomplete.setTypes(['(regions)']);

        autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

        autocomplete.setComponentRestrictions({ 'country': countryRestrictionsArray });

        autocomplete.addListener('place_changed', function () {
            $("body").removeClass("map-search");
            locationMarker.setVisible(false);
            var place = autocomplete.getPlace();

            console.log("place: ", place);

            setKeepSearchingIfNoResults(true);

            if (place === "undefined" || !place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.

                //If we do not get a result here try using the geolocation method instead
                getLocationFromAddress(place.name);

            } else {


                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                    map.setZoom(searchZoomLevel);
                } else {
                    map.setCenter(place.geometry.location);
                    map.setZoom(searchZoomLevel);
                }

                //locationMarker.setPosition(place.geometry.location);
                locationMarker.setVisible(true);
                //useGeoLocation();
                shvenergy.search.gui.mapStateStore.mapVisible = true;
                shvenergy.tracking.trackEvent(input.dataset.category, input.dataset.action, place.name);
                shvenergy.search.gui.historyPushState(input.value);
                shvenergy.search.gui.mapClearSearchButtonStore.clearSearchButtonVisible = true;

                shvenergy.tracking.trackRawEventData({
                    'event': 'clickDFSearch',
                    'searchType': 'Manual search',
                    'query': place.name
                });

            }
        });
    }

    function init() {
        var searchParams = shvenergy.utils.getUrlParameter('search');
        var dealerId = shvenergy.utils.getUrlParameter('dealerId');
        var viewType = shvenergy.utils.getUrlParameter('view')

        $("body").addClass("map map-search");

        if (searchParams && viewType && viewType !== "details") {
            shvenergy.search.gui.mapStateStore.mapVisible = true;

            if (viewType && viewType === "list") {
                //Toggle list. Map is default
                shvenergy.search.gui.mapStateStore.mapVisible = false;
            }
        }

        goToDealerFromURLId(dealerId);
        setDefaultFilterFromUrlParam();

        document.body.addEventListener("click", function (e) {

            if (shvenergy.cookies.getCookie("isTouch") === "true") {

                if (e.target.nodeName === "IMG" && e.target.closest("div").hasAttribute("title")) {
                    return;
                }

                if (!e.target.closest(".info-box") !== null) {
                    //console.log("Du har klikket uden for boksen");
                    removeMobileInfoBoxes();
                }
            }

        });

        map = new google.maps.Map(document.getElementById("map"), {
            center: defaultPosition,
            zoom: initialZoom,
            minZoom: 5,
            zoomControl: true,
            mapTypeControl: false,
            allowTaint: true,
            useCORS: true,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: true,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },

            styles: mapStyles
        });

        locationMarker = new google.maps.Marker({
            map: map,
            anchorPoint: new google.maps.Point(0, -29),
            icon: currentLocationMarker
        });

        mapservice = new google.maps.places.PlacesService(map);

        initializeAutocomplete();

        $('#map-searchbutton').on("click", function (e) {

            $("body").removeClass("map-search");
            const searchText = input.value;

            if (searchText.length > 0) {
                shvenergy.search.gui.historyPushState(searchText);

                shvenergy.tracking.trackEvent(input.dataset.category, input.dataset.action, searchText);

                getLocationFromAddress(searchText);
                return;
            }

        });

        markerClusterer = new MarkerClusterer(map, markers, mcOptions);

        map.addListener('bounds_changed', function () {
            var bounds = map.getBounds();
            if (!bounds) {
                return;
            }

            shvenergy.bounce.runNamed("mapBoundsChanged", function () {
                searchByLocation("bounds_changed");
            }, 500);
        });

        shvenergy.search.filters.updateFiltersByType();
        shvenergy.search.filters.updateFilterCount();

        useGeoLocation();
        storeZoomAndBounds();

        if (!dealerId && searchParams && searchParams.length) {
            $("#map-searchinput").val(searchParams);
            shvenergy.search.gui.mapClearSearchButtonStore.clearSearchButtonVisible = true;
            setTimeout(function () {

                getLocationFromAddress(searchParams);

            }, 1200);
        }

    }

    function getLocationFromAddress(address) {

        const request = {
            address: address
        };

        geoCoder.geocode(request, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                if (results[0]) {

                    //run through address components 
                    if (results[0].address_components) {

                        var countryIsOk = false;

                        results[0].address_components.forEach(function (element) {

                            if (element.hasOwnProperty('short_name')) {

                                if (countryRestrictionsArray.includes(element.short_name.toLowerCase())) {
                                    countryIsOk = true;
                                }
                            }
                        });

                        if (countryIsOk) {
                            setKeepSearchingIfNoResults(true);
                            var myLatlng = new google.maps.LatLng(results[0].geometry.location.lat(),
                                results[0].geometry.location.lng());
                            //locationMarker.setPosition(myLatlng);
                            //locationMarker.setVisible(true);
                            setCenter(myLatlng);
                            map.setZoom(searchZoomLevel);
                        }
                    }
                }
            }
        });
    }

    function searchByLocation(src) {
        //console.log(src);
        const bounds = map.getBounds();
        const zoomLevel = map.getZoom();
        shvenergy.search.dealer.searchByLocation(bounds, zoomLevel);
    }

    function handleLocationError(browserHasGeolocation) {
        console.log(browserHasGeolocation ?
            'Error: The Geolocation service failed.' :
            'Error: Your browser doesn\'t support geolocation.');
    }

    function validCountry(result) {
        var components = result.address_components;
        for (var i = 0; i < components.length; i++) {
            //console.log(components[i]);
            if (countryRestrictionsArray.includes(components[i].short_name.toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    function useGeoLocation(zoomClose) {

        locationMarker.setVisible(false);

        // Try HTML5 geolocation.
        if (navigator.geolocation) {

            console.log("The browser supports geolocation");

            navigator.geolocation.getCurrentPosition(
                successCallback,
                errorCallbackHighAccuracy, {
                maximumAge: 600000,
                timeout: 5000,
                enableHighAccuracy: true
            }
            );

            function errorCallbackHighAccuracy(error) {
                if (error.code == error.TIMEOUT) {
                    // Attempt to get GPS loc timed out after 5 seconds, 
                    // try low accuracy location
                    console.log("attempting to get low accuracy location");
                    navigator.geolocation.getCurrentPosition(
                        successCallback,
                        errorCallbackLowAccuracy,
                        { maximumAge: 600000, timeout: 10000, enableHighAccuracy: false });
                    return;
                }

                var msg = "Can't get your location (high accuracy attempt). Error = ";
                if (error.code == 1)
                    msg += "PERMISSION_DENIED";
                else if (error.code == 2)
                    msg += "POSITION_UNAVAILABLE";
                msg += ", msg = " + error.message;

                console.log(msg);
                $("#useCurrentLocationButton").hide();
            }

            function errorCallbackLowAccuracy(error) {
                var msg = "Can't get your location (low accuracy attempt). Error = ";
                if (error.code == 1)
                    msg += "PERMISSION_DENIED";
                else if (error.code == 2)
                    msg += "POSITION_UNAVAILABLE";
                else if (error.code == 3)
                    msg += "TIMEOUT";
                msg += ", msg = " + error.message;

                console.log(msg);
                $("#useCurrentLocationButton").hide();
            }

            function successCallback(position) {

                console.log("Current position is", position);

                var latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

                geoCoder.geocode({ 'latLng': latLng }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {

                        console.log("GeocoderStatus is OK");

                        if (results[0]) {

                            console.log("We have a result", results[0]);
                            var formattedAddress = results[0].formatted_address;
                            console.log("formattedAddress:", formattedAddress);

                            if (!validCountry(results[0])) {
                                //for now dont so anything if not within selected country
                                console.log("You don't seem to be in a country with a countrycode of:", countryRestrictions);
                                $("#useCurrentLocationButton").hide();
                            }
                            else {
                                console.log("You do in fact seem to be in a country with a countrycode of:", countryRestrictions);
                                /*if (formattedAddress) {
                                    $("#map-searchinput").val(formattedAddress);
                                    shvenergy.search.gui.mapClearSearchButtonStore.clearSearchButtonVisible = formattedAddress.length > 0;
                                }*/
                                locationMarker.setPosition(latLng);
                                locationMarker.setVisible(true);
                                //map.setPosition(latlng);
                                map.setCenter(latLng);
                                //searchByLocation("bounds_changed");

                                if (zoomClose) {
                                    setKeepSearchingIfNoResults(true);
                                    map.setZoom(searchZoomLevel);
                                }

                            }
                        }
                    }
                });

            }

        } else {
            // Browser doesn't support Geolocation
            $("#useCurrentLocationButton").hide();
            handleLocationError(false);
        }
    }

    let myMarkers = [];

    function checkDealerIcon(pinId) {
        for (let i = 0; i < myMarkers.length; i++) {
            if (myMarkers[i].id === pinId) {
                return true;
            }
        }
        return false;
    }

    function buildDealerIcons(pins, markDone) {
        if (!pins || pins.length === 0) {
            markDone('No pins to generate.');
            return;
        }

        const state = {
            pinsToHandle: pins.length
        };

        pins.forEach(function (pin) {
            if (!checkDealerIcon(pin.id)) {
                buildIcon(pin, stepDone);
            } else {
                stepDone();
            }
        });

        function stepDone() {
            state.pinsToHandle -= 1;
            if (state.pinsToHandle === 0) {
                markDone('Pins handled.');

                // Wait for pins to be ready before we click one
                var dealerId = shvenergy.utils.getUrlParameter('dealerId');
                if (dealerId) {
                    clickMarkerById(activeMarker)
                }
            }
        }
    }

    function buildIcon(pin, stepDone) {
        if (pin.urls.length === 1) {
            myMarkers.push({
                id: pin.id,
                url: pin.urls[0]
            });
            stepDone();
        } else {
            var urlArr = [];
            pin.urls.forEach(function (pinurl) {
                if (pinurl.toLowerCase().includes(cdnvalue.toLowerCase())) {
                    urlArr.push(pinurl.toLowerCase().replace(cdnvalue.toLowerCase(), ""));
                }
                else {
                    urlArr.push(pinurl);
                }
            });

            mergeImages(urlArr).then(function (b64) {
                myMarkers.push({
                    id: pin.id,
                    url: b64
                });
                stepDone();
            });
        }
    }

    function getDealerIcon(pinId) {
        return myMarkers.find(x => x.id === pinId).url;
    }

    function removeMobileInfoBoxes() {
        var elements = document.getElementsByClassName('info-box');
        while (elements.length > 0) {
            elements[0].remove();
        }
    }

    function loadDealer(id) {
        shvenergy.search.dealer.getDetails(id);
        storeZoomAndBounds();
    }

    function createDealerMarkers(data) {
        // https://developers.google.com/maps/documentation/javascript/markers
        // https://developers.google.com/maps/documentation/javascript/symbols

        var iconsPromise = new Promise(function (resolve, reject) {
            buildDealerIcons(data.iconPins, resolve);
        });

        var clusterIcons = $('.marker-cluster-icon');
        clusterIcons.remove();

        iconsPromise.then(function (value) {
            console.log(value);// expected output: "icons done"
            //console.log(myMarkers);

            markerClusterer.clearMarkers();
            deleteMarkers();

            $("#useCurrentLocationButton").show();
            var count = data.Count;
            //var distanceUnit = data.distanceUnit;
            var dealers = data.Dealers;
            var showDirections = data.ShowGetDirections || false;

            dealerTarget.empty();

            if (count < minimumnumbersofdealersshownonmapafterinitialsearch && getKeepSearchingIfNoResults()) {
                console.log(`Not enough results. Must show at least ${minimumnumbersofdealersshownonmapafterinitialsearch}, so zooming out 1 step.`);
                shvenergy.maps.setZoom(shvenergy.maps.getZoom() - 1);
                return;

            } else {
                setKeepSearchingIfNoResults(false);
            }

            if (count <= 0) {
                var errorString = window.noResultsErrorMessages.NoResultNoDealersInArea.replace(/(\n)+/g, '<br />');
                errorMessage.html(errorString);
                $(".search__details--error").show();

                if (getKeepSearchingIfNoResults()) {
                    var myZoom = shvenergy.maps.getZoom();
                    shvenergy.maps.setZoom(myZoom - 2);
                }
                return;
            }

            setKeepSearchingIfNoResults(false);

            $(".search__details--error").hide();

            if (count <= numberofsearchresultsbeforeserversideclustering) {

                for (let dealerCounter = 0; dealerCounter < dealers.length; dealerCounter++) {

                    var marker = new google.maps.Marker({
                        position: dealers[dealerCounter].geometry.location,
                        //icon: "/dist/images/maps/" + iconResolver(dealers[dealerCounter].icon),

                        icon: getDealerIcon(dealers[dealerCounter].iconPinId),

                        id: dealers[dealerCounter].id,
                        description: dealers[dealerCounter].description,
                        dealerPhones: dealers[dealerCounter].dealerPhones,
                        isPreferredPartner: dealers[dealerCounter].isPreferredPartner,
                        distance: dealers[dealerCounter].distance,
                        addresslines: dealers[dealerCounter].addresslines,
                        shortAddress: dealers[dealerCounter].shortAddress,
                    });

                    marker.addListener("click", function () {
                        shvenergy.tracking.trackRawEventData({
                            'event': 'clickDFRetailer',
                            'retailerName': this.description
                        });

                        removeMobileInfoBoxes();

                        const isMobile = shvenergy.cookies.getCookie('isTouch') === 'true' && window.matchMedia('(max-width: 640px').matches;

                        if (!isMobile) {
                            //console.log("Du er med al sandsynlighed på et desktop device");
                            if (!isZoomedAndCenteredOnMarker) {
                                shvenergy.maps.loadDealer(this.id);
                                //shvenergy.maps.zoomAndCenterOnMarker(this);
                            }

                            return;
                        }

                        map.setCenter(this.position);

                        var mobileInfoBox = document.createElement("div");

                        mobileInfoBox.style.position = 'fixed';
                        mobileInfoBox.style.bottom = '0';
                        mobileInfoBox.style.left = '0';
                        mobileInfoBox.style.right = '0';
                        mobileInfoBox.style.backgroundColor = '#fff';
                        mobileInfoBox.style.zIndex = '99999';

                        mobileInfoBox.classList.add("info-box");

                        let dealerPhones = "";

                        if (this.dealerPhones && this.dealerPhones.length) {
                            dealerPhones = `<a style="min-width: 0;font-size:14px;" class="button" href="tel:${this.dealerPhones[0]}">
                                                    <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><use xlink:href="/dist/svgsprite/icons.svg#Phone_16x16"></use></svg>
                                                    <span>${this.dealerPhones[0]}</span>
                                                </a>`;
                        }

                        let isPref = "";
                        if (this.isPreferredPartner && usePreferredPartenerLabel()) {

                            var l = extractLabelFromFilter();

                            isPref = `<span class="preferred-partner">${l}</span>`;
                        }

                        let dist = "";

                        if (this.distance) {
                            dist = `<span class="distance">${this.distance} ${distanceUnit}</span>`;
                        }

                        //let header = "";
                        //if (truncatelongdealernames.toLowerCase() === "true") {
                        //    header = `<h3 class="truncate">${this.description}</h3>`;
                        //} else {
                        //    header = `<h3>${this.description}</h3>`;
                        //}

                        let header = `<h4 style="margin:0;">${this.description}</h4>`;

                        var markerLocation = getDefaultMarkerLocation();

                        var directions = '';
                        if (markerLocation !== null && (showDirections === "true" || showDirections === true)) {
                            directions = `<a style="min-width: 0;font-size:14px;" href="https://www.google.com/maps/dir/${markerLocation.lat()},${markerLocation.lng()}/${this.position.lat()},${this.position.lng()}/data=!3m1!4b1!4m2!4m1!3e0" class="button" target="_blank" rel="noopener">
                                                <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><use xlink:href="/dist/svgsprite/icons.svg#Get-directions_16x16"></use></svg>
                                                <span>${getdirectionstext}</span>
                                          </a>`;
                        }


                        let dealerPhonesAndDirections = '';
                        if (dealerPhones !== '' || directions !== '') {
                            dealerPhonesAndDirections =
                                `<div class="infoBox__ctas">
                                            ${dealerPhones}
                                            ${directions}
                                    </div>`;
                        }

                        let shortAddressDiv = '';
                        if (this.shortAddress && getMobileAddressSettings().showAddressInDealerPreviewBox) {
                            shortAddressDiv = `<div>${this.shortAddress}</div>`
                        }

                        mobileInfoBox.innerHTML = `
                                <div class="infoBox__text">
                                    <button>
                                        <div style="flex:none;"><img src="${this.icon}" width="80" height="60" alt="" style="width:60px;height:45px;" /></div>
                                        <div class="infoBox__text__details">
						                    <p class="search__item__text__openhours">
                                                ${dist}
                                                ${isPref}
                                            </p>
                                            ${header}
                                            ${shortAddressDiv}
                                        </div>
                                        <div class="infoBox__text__arrow">
                                            <div>
                                                <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><use xlink:href="/dist/svgsprite/icons.svg#Arrow_No-stem_16x16"></use></svg>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                                ${dealerPhonesAndDirections}
                                `;

                        $(mobileInfoBox).on('click', 'button', (e) => {
                            loadDealer(this.id);
                            e.preventDefault();
                        })

                        document.querySelector("body").appendChild(mobileInfoBox);

                        // Create shareable URL for a specific dealer and add to browser history
                        var dealerLocation = getMarkerById(this.id);
                        var searchUrl = new URL(window.location);
                        var oldDealerId = parseInt(searchUrl.searchParams.get("dealerId"));

                        if (oldDealerId !== this.id) {
                            searchUrl.searchParams.set("dealerId", this.id);
                            searchUrl.searchParams.set("lat", dealerLocation.position.lat());
                            searchUrl.searchParams.set("lng", dealerLocation.position.lng());
                            window.history.pushState({}, '', searchUrl);
                        }
                    });

                    marker.addListener("mouseover", function () {
                        if (infoBox) {
                            infoBox.close();
                        }

                        setMarker(this.id, true);

                        var boxText = document.createElement("div");
                        //					console.log(this);
                        var dealerPhones = (this.dealerPhones && this.dealerPhones.length) ? this.dealerPhones.join("<br>") : "";

                        let isPref = "";
                        if (this.isPreferredPartner && usePreferredPartenerLabel()) {

                            var l = extractIconAndLabelFromFilter();

                            isPref = `<span class="preferred-partner">${l}</span>`;
                        }

                        let dist = "";

                        if (this.distance) {
                            dist = `<span class="distance">${this.distance} ${distanceUnit}</span>`;
                        }

                        let header = "";

                        if (truncatelongdealernames.toLowerCase() === "true") {
                            header = `<h3 class="truncate">${this.description}</h3>`;
                        } else {
                            header = `<h3>${this.description}</h3>`;
                        }

                        boxText.innerHTML = `<div class="infoBox__text">
						<p class="search__item__text__openhours">${isPref}${dist}</p>
                         ${header}
						<p>${dealerPhones}</p>
					</div><div class="infoBox__footer"></div>`;

                        var infoBoxOptions = {
                            content: boxText,
                            pixelOffset: new google.maps.Size(-140, -80),
                            infoBoxClearance: new google.maps.Size(1, 1)
                        };

                        var mergedOptions = Object.assign({}, infoBoxDefaultOptions, infoBoxOptions);

                        infoBox = new InfoBox(mergedOptions);
                        infoBox.open(map, this);

                    });

                    marker.addListener("mouseout", function () {
                        if (infoBox) {
                            infoBox.close();
                        }

                        setMarker(this.id, false);
                    });

                    markers.push({
                        marker: marker,
                        id: dealers[dealerCounter].id
                    });

                    markerClusterer.addMarker(marker);
                }

                if (dealers.length <= 0) {
                    console.log("Ever here????");
                    return;
                }
                if (dealers.length <= numberofsearchresultbeforeshowingsearchresults) {
                    createDealerList(dealers);
                    resultList.addClass("search__pane--active");
                    shvenergy.search.gui.setBactoStartState(false);
                    resultListWarning.hide();
                } else {
                    resultList.removeClass("search__pane--active");
                    intro.show();
                    resultListWarning.show();
                    //errorMessage.html(window.noResultsErrorMessages.NoResultTooManyDealersInArea);// + " " + window.noResultsErrorMessages.NoResultGuideNewsearch);
                    //$(".search__details--error").show();
                }
                if (count == 1) {
                    shvenergy.tracking.trackEvent('Dealerfinder', 'Dealer zoomed', dealers[0].id);
                }

            } else {

                // console.log("Serverside clustering");

                for (var i = 0; i < dealers.length; i++) {

                    var clusterSize = dealers[i].size;
                    var clusterSizeLength = clusterSize.toString().length;

                    var clusterLabel = {
                        text: " ",
                        color: "white"
                    };

                    if (useClusterSizeAsText) {
                        clusterLabel = {
                            text: "" + clusterSize.toString(),
                            color: "white"
                        };
                    }

                    var marker2 = new google.maps.Marker({
                        position: dealers[i].geometry.location,
                        map: map,
                        icon: imagePath + clusterSizeLength + ".png",
                        label: clusterLabel,
                        bounds: dealers[i].geometry.bounds
                    });

                    marker2.addListener("click", function () {

                        //if (markerClusterer.isZoomOnClick()) {
                        //  //Zoom into the cluster.
                        // this.map_.fitBounds(this.cluster_.getBounds());
                        //}

                        //map.fitBounds(this.bounds);

                        console.log(this.bounds);
                        var pos = this.position;
                        map.setZoom(map.getZoom() + 1);
                        map.setCenter(pos);
                        //fitBounds(new google.maps.LatLngBounds(this.bounds.sw, this.bounds.ne));
                        //map.setCenter(pos);
                        //setTimeout(function () {
                        //    map.setZoom(map.getZoom() + 1);
                        //}, 200);
                    });
                    markers.push({
                        marker: marker2,
                        id: dealers[i].id
                    });

                }
            }
        });

    }

    function createDealerList(dealers) {
        //console.log(dealers);
        var localDealers = [];
        var localMarkers = markerClusterer.getMarkers();

        for (var t = 0; t < localMarkers.length; t++) {
            //console.log(localMarkers[t]);

            //if (localMarkers[t].map == null)
            //    continue;
            //else {
            if (localMarkers[t].hasOwnProperty('id')) {
                var id = localMarkers[t].id;

                var filterObj = dealers.filter(function (obj) {
                    return obj.id == id;
                });

                //console.log(filterObj);
                localDealers.push(filterObj);
            }
            //}

        }
        if (localDealers.length > 0) {
            console.log({ localDealers });

            dealerTarget.loadTemplate(dealerTemplate, localDealers.slice(0, numberofsearchresultbeforeshowingsearchresults), { append: true });
            $("#useCurrentLocationButton").hide();
        } else {
            $("#useCurrentLocationButton").show();
        }

    }

    function setMapOnAll(map) {
        for (var i = 0; i < markers.length; i++) {

            markers[i].marker.setMap(map);
        }
    }

    function clearMarkers() {
        setMapOnAll(null);
    }

    function deleteMarkers() {
        clearMarkers();
        markers = [];
    }

    function pan(xOffset, yOffset) {
        map.panBy(xOffset, yOffset);
    }

    function setLocation(location, zoom, skiplocation) {
        map.setCenter(location);
        if (zoom) {
            map.setZoom(zoom);
        }

        if (skiplocation)
            return;

        //showLocation(location);

        // TODO: Skew by some distance?
        //pan((mapSidebar.width() * -1) / 2, 0);

    }

    function fitBounds(bounds) {

        // TODO: Skew by some distance?
        if (bounds)
            map.fitBounds(bounds);

    }

    function getBounds() {
        return map.getBounds();
    }

    function getZoom() {
        return map.getZoom();
    }

    function setZoom(zoom) {
        map.setZoom(zoom);
    }

    function setCenter(position) {
        map.setCenter(position);
    }

    function getStoredZoom() {
        return currentZoom;
    }

    function getStoredBounds() {
        return currentBounds;
    }

    function storeZoomAndBounds() {
        if (!isZoomedAndCenteredOnMarker) {
            currentZoom = getZoom();
            currentBounds = getBounds();
        }
    }

    function zoomAndCenterOnMarker(marker) {
        shvenergy.maps.setCenter(marker.position);
        shvenergy.maps.setZoom(18);
        setIsZoomedAndCenteredOnMarker(true);
    }

    function setIsZoomedAndCenteredOnMarker(value) {
        isZoomedAndCenteredOnMarker = value;
    }

    function getDefaultMarkerLocation() {
        if (locationMarker) {
            var v = locationMarker.getVisible();
            if (v) {
                return locationMarker.getPosition();
            }
            return null;

        }
        return null;
    }

    function getMarkerById(id) {
        for (var i = 0; i < markers.length; i++) {
            if (markers[i].id == id) {
                return markers[i].marker;
            }
        }

        return null;
    }

    function setMarker(dealerId, useDark) {
        var myMarker = getMarkerById(dealerId);
        myMarker.setAnimation(null);
        var str = myMarker.icon;
        var n = str.lastIndexOf("/");
        str = str.substring(n + 1, str.length);

        //If its a cluster dont do anything
        if (str.indexOf("m1.png") !== -1 ||
            str.indexOf("m2.png") !== -1 ||
            str.indexOf("m3.png") !== -1 ||
            str.indexOf("m4.png") !== -1 ||
            str.indexOf("m5.png") !== -1) {

            return;
        }

        //var newImage = "/dist/images/maps/";
        if (useDark) {
            //newImage += str.replace(".png", "") + "-black.png";
            $("[dealerid='" + dealerId + "']").addClass("active");

            myMarker.setAnimation(google.maps.Animation.BOUNCE);
        } else {
            //newImage += str.replace("-black", "");
            $("[dealerid='" + dealerId + "']").removeClass("active");
        }
        //myMarker.setIcon(newImage);

    }

    function getPlaceId(location, dealerName, callback) {

        var request = {
            query: dealerName,
            locationBias: { radius: 100, center: { lat: location.lat, lng: location.lng } },
            fields: ['place_id']
        };

        mapservice.findPlaceFromQuery(request, function (results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                if (results && results.length) {
                    //console.log("A: " + results[0]);
                    //console.log("B: " + results[0].place_id);
                    getDataFromPlaceId(results[0].place_id);
                    if (callback) {
                        callback(results[0].place_id);
                        return;
                    }
                }
            }
            if (callback) {
                callback(undefined);
            }
        });

    }

    function loadGoogleMapsService() {
        return mapservice;
    }

    function getDataFromPlaceId(placeId) {
        //Set placeId on the openinhours button
        $("#openingHoursButton").data("placeId", placeId);

        //We need to check if we have to load placedetails.
        //Initially we only need to do this if "Show phone numbers from Google Maps [shared]" is set to true in sitecore
        //We can check if this is true be searching for id "#GooglePhoneNumber" in the DOM. (see line 59 in "DealerMapDetailsContactInfo.cshtml")

        if ($("#GooglePhoneNumber").length > 0) {

            console.log("Load phone number from Google, and store any place details properties in the store");

            mapservice.getDetails({
                placeId: placeId,
                fields: ['formatted_phone_number']
            }, function (place, status) {

                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    if (place.formatted_phone_number) {
                        shvenergy.search.gui.setGooglePhoneNumber(place.formatted_phone_number);
                        shvenergy.search.gui.mapStateStore.placeDetails = place;
                    }
                }
            });
        }
    }

    function setKeepSearchingIfNoResults(val) {
        keepSearchingIfNoResults = val;
    }

    function getKeepSearchingIfNoResults() {
        return keepSearchingIfNoResults;
    }

    function hideMarker() {
        locationMarker.setVisible(false);
    }

    function areMarkersCreatedAndNotClusters() {
        //this function is used by shvenergy.search.dealer.js
        //In there we need to make sure that markers are not of type cluster
        //Even clusters have an ID property but it is undefined, so that is what we are checking for
        var ok = false;
        for (var i = 0; i < markers.length; i++) {
            if (markers[i].hasOwnProperty("id") && typeof markers[i].id !== "undefined")
                ok = true;
        }
        return ok;
    }


    // TODO: ideally this should be wrapped in a document.load event but this will cause
    // issues on other that depend on the map service and others to be inititalized ASAP.
    // This will require a bigger rework on the init() calls and how we structure this script, 
    // but for LCP preloading, this should suffice.

    // window.addEventListener('load', function (e) {
    /*    const image = mapsContainer.data('pageloadimage');
    
        if (image !== '') {
            var frame = document.createElement('iframe');
            frame.src = image;
    
            frame.style.position = 'absolute';
            frame.style.top = 0;
            frame.style.left = 0;
            frame.style.width = '100%';
            frame.style.height = '100%';
            frame.style.border = '100%';
    
            mapsContainer.append(frame);
        }*/

    init();
    // });

    return {
        init: init,
        initializeAutocomplete,
        pan: pan,
        useGeoLocation: useGeoLocation,
        setLocation: setLocation,
        fitBounds: fitBounds,
        createDealerMarkers: createDealerMarkers,
        getBounds: getBounds,
        getZoom: getZoom,
        getDefaultMarkerLocation: getDefaultMarkerLocation,
        setMarker: setMarker,
        getPlaceId: getPlaceId,
        intro: intro,
        getStoredBounds: getStoredBounds,
        getStoredZoom: getStoredZoom,
        setZoom: setZoom,
        setCenter: setCenter,
        storeZoomAndBounds: storeZoomAndBounds,
        getMarkerById: getMarkerById,
        initialPosition: initialPosition,
        initialZoom: initialZoom,
        getKeepSearchingIfNoResults: getKeepSearchingIfNoResults,
        setKeepSearchingIfNoResults: setKeepSearchingIfNoResults,
        usePreferredPartenerLabel: usePreferredPartenerLabel,
        areMarkersCreatedAndNotClusters: areMarkersCreatedAndNotClusters,
        hideMarker: hideMarker,
        locationMarker: locationMarker,
        loadGoogleMapsService: loadGoogleMapsService,
        loadDealer: loadDealer,
        getLocationFromAddress: getLocationFromAddress,
        zoomAndCenterOnMarker: zoomAndCenterOnMarker,
        setIsZoomedAndCenteredOnMarker: setIsZoomedAndCenteredOnMarker
    };

})(jQuery);